import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Select, Button, Table, Tabs, message, Tooltip} from 'antd'
import dataTargetAPI from '../../../apis/dataTarget'
import {PlusOutlined, MinusOutlined, EyeOutlined, QuestionCircleOutlined} from '@ant-design/icons'
import VerModal from './VerModal'
import Axios from 'axios'
import {Base64} from 'js-base64'
import {withTranslation} from 'react-i18next'

const {TextArea} = Input
const {TabPane} = Tabs

class EditModal extends Component {
  formRef = React.createRef()
  formRefOperation = React.createRef()
  formRefAdition = React.createRef()

  state = {
    xml: false,
    targetType: false,
    verModalVisible: false,
    groovyPopup: null,
    certification: '', // Groovy || OAuth2.0 
    headerData: [],
    bodyData: [],
    customerOption: [],
    groovyOption: [],
    transportProtocol: null,
    line: null,
    popupTitle: null,
    popupData: null,
    operationDel: null,
    current: '0',
    dataTypeValue: '',
    authorization: null,
    keyVaultList: [],
    keyVaultValue: '',
    userList: [],
    testLoading: false
  }

  componentDidMount() {
    const {id} = this.props
    let _this = this
    Axios.all([dataTargetAPI.customerAction(), dataTargetAPI.getKeyVaultNameList(), dataTargetAPI.groovyAction('DATATARGET'), dataTargetAPI.getInfoAction(id)]).then(Axios.spread(function (_customerAction, _keyVaultList, _groovyAction, _getInfoAction) {
      let result = _getInfoAction.data.data
      if (result.keyVault) {
        _this.getNameAndWordByKV(result.keyVault)
      }
      _this.formRef.current.setFieldsValue({
        targetName: result.targetName,
        targetType: result.targetType,
        customer: result.customer,
        description: result.description,
        apiUrl: result.configInfo.apiUrl,
        contentType: result.configInfo.contentType,
        pre: result.configInfo.pre,
        certification: result.configInfo.certification,
        authorization: result.configInfo.authorization,
        groovy: result.configInfo.groovy,
        Header: result.configInfo.header,
        transportProtocol: result.configInfo.transportProtocol,
        charset: result.configInfo.charset,
        // Body: result.configInfo.body,
        username: result.configInfo.username,
        password: result.configInfo.password,
        driverName: result.configInfo.driverName,
        url: result.configInfo.url,
        address: result.configInfo.address,
        port: result.configInfo.port,
        connectStr: result.configInfo.connectStr,
        containerName: result.configInfo.containerName,
        // isPublic: result.configInfo.isPublic ? '1' : '2',
        keyVault: result.keyVault
      })
      _this.setState({
        groovyPopup: result.configInfo.groovy,
        targetType: result.targetType === 'HTTP' ? true : false,
        dataTypeValue: result.targetType,
        xml: result.configInfo.contentType === 'XML' ? true : false,
        transportProtocol: result.configInfo.transportProtocol,
        certification: result.configInfo.certification,
        authorization: result.configInfo.authorization,
        customerOption: _customerAction.data.data,
        groovyOption: _groovyAction.data.data,
        keyVaultList: _keyVaultList.data.data,
        keyVaultValue: result.keyVault,
        operationDel: result.configInfo.transportProtocol === 'SOAP' ? result.configInfo.operation.map(item => item.canDelete) : []
      })
      if (result.configInfo.transportProtocol === 'HTTP') {
        let origin = result.configInfo.operation
        if (origin.length === 0) {
          origin = [
            {id: 'HTTP_0', operationName: '', method: 'GET'},
            {id: 'HTTP_1', operationName: '', method: 'POST'}
          ]
        }

        if (origin.length === 1) {
          if (origin[0].method === 'GET') {
            origin.push({id: 'HTTP_1', operationName: '', method: 'POST'})
          } else {
            origin.unshift({id: 'HTTP_0', operationName: '', method: 'GET'})
          }
        }
        _this.formRefOperation.current.setFieldsValue({
          operationH: origin
        })
      } else if (result.configInfo.transportProtocol === 'SOAP') {
        _this.formRefOperation.current.setFieldsValue({
          operationS: result.configInfo.operation.length > 0 ? result.configInfo.operation : [{operationName: '', soapAction: '', nameSpace: ''}]
        })
        _this.formRefAdition.current.setFieldsValue({
          soapHeader: result.configInfo.detail?.soapHeader.length > 0 ? result.configInfo.detail.soapHeader : [{value: '', key: ''}]
        })
      }
    }))
  }

  handleOk = () => {
    const {handleCancel, handleSearch, id} = this.props

    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        id,
        targetName: fieldsValue.targetName,
        targetType: fieldsValue.targetType,
        customer: fieldsValue.customer,
        description: fieldsValue.description,
        keyVault: fieldsValue.keyVault,
        configInfo: {
          charset: fieldsValue.charset,
          transportProtocol: fieldsValue.transportProtocol,
          apiUrl: Base64.encode(fieldsValue.apiUrl),
          contentType: fieldsValue.contentType,
          pre: fieldsValue.pre !== undefined ? Base64.encode(fieldsValue.pre) : null,
          certification: fieldsValue.certification,
          authorization: fieldsValue.authorization,
          groovy: fieldsValue.groovy,
          header: fieldsValue.Header,
          // body: fieldsValue.Body,
          username: fieldsValue.username ? Base64.encode(fieldsValue.username) : null,
          password: fieldsValue.password ? Base64.encode(fieldsValue.password) : null,
          driverName: fieldsValue.driverName,
          url: Base64.encode(fieldsValue.url),
          address: fieldsValue.address,
          port: fieldsValue.port,
          connectStr: Base64.encode(fieldsValue.connectStr),
          containerName: fieldsValue.containerName,
          // isPublic: fieldsValue.isPublic === '1' ? true : false,
        }
      }
      if (this.state.transportProtocol === 'HTTP') {
        this.formRefOperation.current.validateFields().then(fieldsValue2 => {
          params.configInfo.operation = fieldsValue2.operationH
          dataTargetAPI.addAction(params).then(res => {
            handleCancel('editModalVisible')
            handleSearch()
            message.success('Success!')
          })
        })
      } else if (this.state.transportProtocol === 'SOAP') {
        this.formRefOperation.current.validateFields().then(fieldsValue2 => {
          let arr = fieldsValue2.operationS.map((item, index) => {
            item.id = `SOAP_${index}`
            return item
          })
          params.configInfo.operation = arr
          this.formRefAdition.current.validateFields().then(fieldsValue3 => {
            params.configInfo.detail = fieldsValue3
            dataTargetAPI.addAction(params).then(res => {
              handleCancel('editModalVisible')
              handleSearch()
              message.success('Success!')
            })
          })
        })
      } else {
        dataTargetAPI.addAction(params).then(res => {
          handleCancel('editModalVisible')
          handleSearch()
          message.success('Success!')
        })
      }
    }).catch(err => { })
  }

  onChangeContentType = (value) => {
    this.setState({
      xml: value === 'XML' ? true : false
    })
    this.formRef.current.setFieldsValue({
      transportProtocol: null
    })
    this.setState({
      transportProtocol: null
    })
  }

  onChangeCertification = (value) => {
    this.setState({
      certification: value
    })
  }

  onChangetargetType = (value) => {
    this.setState({
      targetType: value === 'HTTP' ? true : false
    })
  }

  onChangeauthorization = (value) => {
    this.setState({
      authorization: value
    })
  }

  onChangegroovy = (value) => {
    this.setState({
      groovyPopup: value
    })
  }

  handleVer = () => {
    if (this.formRef.current.getFieldValue('groovy')) {
      this.setState({
        verModalVisible: true
      })
    }
  }

  handlePopupCancel = (target) => {
    this.setState({
      [target]: false
    })
  }

  onChangetransportProtocol = (value) => {
    this.setState({
      transportProtocol: value
    })
  }
  // 切换step
  onTabChange = (value) => {
    if (this.state.current === '0') {
      this.formRef.current.validateFields().then((values) => {
        this.setState({
          current: value
        })
      }).catch(err => {
        console.log(err)
      })
    } else if (this.state.current === '1') {
      this.formRefOperation.current.validateFields().then((values) => {
        let arr = []
        values.operationH.map((item) => {
          if (item.operationName) {
            arr.push(item.operationName)
          }
          return arr
        })
        if (arr.length > 0) {
          this.setState({
            current: value
          })
        } else {
          message.warning('Please input Operation Name!')
        }
      }).catch(err => {
        console.log(err)
      })
    } else if (this.state.current === '2') {
      this.formRefAdition.current.validateFields().then((values) => {
        this.setState({
          current: value
        })
      }).catch(err => {
        console.log(err)
      })
    }
  }
  handleNext = (value) => {
    if (value === '0') {
      this.formRef.current.validateFields().then((values) => {
        this.setState({
          current: '1'
        })
      }).catch(err => {
        console.log(err)
      })
    } else if (value === '1') {
      this.formRefOperation.current.validateFields().then((values) => {
        let arr = []
        values.operationH.map((item) => {
          if (item.operationName) {
            arr.push(item.operationName)
          }
          return arr
        })
        if (arr.length > 0) {
          this.setState({
            current: '2'
          })
        } else {
          message.warning('Please input Operation Name!')
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
  handlePrev = (value) => {
    if (value === '1') {
      this.formRefOperation.current.validateFields().then((values) => {
        this.setState({
          current: '0'
        })
      }).catch(err => {
        console.log(err)
      })
    } else if (value === '2') {
      this.formRefAdition.current.validateFields().then((values) => {
        this.setState({
          current: '1'
        })
      }).catch(err => {
        console.log(err)
      })
    }
  }

  handleTestConnection = () => {
    this.setState({
      testLoading: true
    })
    let params = {}
    this.formRef.current.validateFields().then(fieldsValue => {
      if (this.state.dataTypeValue === 'DB') {
        params = {
          driverName: fieldsValue.driverName,
          connectionStr: Base64.encode(fieldsValue.url),
          username: Base64.encode(fieldsValue.username),
          password: Base64.encode(fieldsValue.password),
          keyVault: fieldsValue.keyVault
        }
        dataTargetAPI.textDB(params).then(res => {
          message.success('Success!')
          this.setState({
            isTested: true,
            testLoading: false
          })
        }).catch(() => [
          this.setState({
            testLoading: false
          })
        ])
      } else if (this.state.dataTypeValue === 'SFTP') {
        params = {
          host: fieldsValue.address,
          userName: Base64.encode(fieldsValue.username),
          password: Base64.encode(fieldsValue.password),
          port: fieldsValue.port,
          keyVault: fieldsValue.keyVault
        }
        dataTargetAPI.textSFTP(params).then(res => {
          message.success('Success!')
          this.setState({
            isTested: true,
            testLoading: false
          })
        }).catch(() => [
          this.setState({
            testLoading: false
          })
        ])
      } else if (this.state.dataTypeValue === 'Blob') {
        params = {
          connectStr: Base64.encode(fieldsValue.connectStr),
          containerName: fieldsValue.containerName,
          keyVault: fieldsValue.keyVault
        }
        dataTargetAPI.textBlob(params).then(res => {
          message.success('Success!')
          this.setState({
            isTested: true,
            testLoading: false
          })
        }).catch(() => [
          this.setState({
            testLoading: false
          })
        ])
      }
    })
  }

  getNameAndWordByKV = (id) => {
    dataTargetAPI.getNameAndWordByKV(id).then(res => {
      this.setState({
        userList: res.data.data
      })
    })
  }

  onChangeKeyVault = (value) => {
    if (value) {
      this.getNameAndWordByKV(value)
      this.setState({
        keyVaultValue: value,
        isTested: false
      })

      this.formRef.current.setFieldsValue({
        username: null,
        password: null,
        connectStr: null
      })
    }
  }

  onClearKeyVault = () => {
    this.setState({
      keyVaultValue: ''
    })

    this.formRef.current.setFieldsValue({
      username: null,
      password: null,
      connectStr: null
    })
  }

  render() {
    const {editModalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={`${t(`general.edit`)} ${t(`dataTarget.dataTarget`)}`}
          width="70%"
          closable={true}
          visible={editModalVisible}
          onCancel={() => { handleCancel('editModalVisible') }}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={
            this.state.dataTypeValue === 'HTTP' ?
              (this.state.current === '0' ? (
                [
                  <Button key="Next" type="primary" onClick={() => { this.handleNext('0') }}>{t(`general.next`)}</Button>,
                  <Button key="Cancel" onClick={() => { handleCancel('editModalVisible') }}>{t(`general.cancel`)}</Button>,
                ]
              ) : this.state.current === '1' ? (
                [
                  <Button key="Prev" onClick={() => { this.handlePrev('1') }}>{t(`general.prev`)}</Button>,
                  <Button key="Next" type="primary" onClick={() => { this.handleNext('1') }}>{t(`general.next`)}</Button>,
                  <Button key="Cancel" onClick={() => { handleCancel('editModalVisible') }}>{t(`general.cancel`)}</Button>,
                ]
              ) : (
                [
                  <Button key="Prev" onClick={() => { this.handlePrev('2') }}>{t(`general.prev`)}</Button>,
                  <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
                  <Button key="Cancel" onClick={() => { handleCancel('editModalVisible') }}>{t(`general.cancel`)}</Button>,
                ]
              ))
              : (
                this.state.dataTypeValue === 'DB' || this.state.dataTypeValue === 'SFTP' || this.state.dataTypeValue === 'Blob' ? ([
                  <Button key="TestConnection" loading={this.state.testLoading} onClick={this.handleTestConnection}>Test Connection</Button>,
                  <Button key="Save" type="primary" onClick={this.handleOk} disabled={!this.state.isTested}>{t(`general.save`)}</Button>,
                  <Button key="Cancel" onClick={() => { handleCancel('editModalVisible') }}>{t(`general.cancel`)}</Button>,
                ]) : (
                  [
                    <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
                    <Button key="Cancel" onClick={() => { handleCancel('editModalVisible') }}>{t(`general.cancel`)}</Button>,
                  ]
                )
              )
          }
        >
          <Tabs defaultActiveKey="0" activeKey={this.state.current} onChange={this.onTabChange} style={{marginBottom: '30px'}}
                className="messagesTabs">
            <TabPane tab={t(`dataTarget.base`)} key="0"></TabPane>
            {
              this.state.dataTypeValue === 'HTTP' ?
                <>
                  <TabPane tab={t(`dataTarget.operation`)} key="1"></TabPane>
                  <TabPane tab={t(`dataTarget.addition`)} key="2"></TabPane>
                </> : null
            }
          </Tabs>
          <Form ref={this.formRef} key="formRef" style={{display: this.state.current !== '0' ? 'none' : ''}} layout="vertical">
            <Row justify="start" gutter={[10, 0]}>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="targetName" label={t(`dataTarget.targetName`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.targetName`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="targetType" label={t(`dataTarget.targetType`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.targetType`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangetargetType} disabled>
                    <Select.Option key="HTTP" value="HTTP">HTTP</Select.Option>
                     <Select.Option key='DB' value='DB'>DB</Select.Option>
                    <Select.Option key="SFTP" value="SFTP">SFTP</Select.Option>
                    <Select.Option key="Blob" value="Blob">Blob</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="customer" label={t(`dataTarget.customer`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.customer`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled>
                    {
                      this.state.customerOption.map((e, i) => {
                        return (
                          <Select.Option key={e.id} value={e.id}>{e.customer}</Select.Option>
                        )
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>

              {
                this.state.dataTypeValue === 'DB' ? (
                  <>
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="driverName" label={t(`dataTarget.driverName`)}
                                 rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.driverName`)}`}]}>
                        <Select placeholder={t(`general.pleaseSelect`)} onChange={() => { this.setState({isTested: false}) }} allowClear>
                          <Select.Option key="MySQL" value="MySQL">MySQL</Select.Option>
                          <Select.Option key="Oracle" value="Oracle">Oracle</Select.Option>
                          <Select.Option key="PgSQL" value="PgSQL">PgSQL</Select.Option>
                          <Select.Option key="SqlServer" value="SqlServer">SqlServer</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="url" label={t(`dataTarget.url`)}
                                 rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.url`)}`}]}>
                        <Input maxLength={500} placeholder={t(`general.pleaseEnter`)} onChange={() => { this.setState({isTested: false}) }}/>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item label={t(`dataTarget.keyVault`)} name="keyVault"
                                 style={{display: 'inline-flex', width: 'calc(100% - 30px)', marginRight: '10px'}}>
                        <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeKeyVault} onClear={this.onClearKeyVault}>
                          {
                            this.state.keyVaultList.length > 0 && this.state.keyVaultList.map((item) => {
                              return (
                                <Select.Option key={item.id} value={item.id}>{item.keyVaultName}</Select.Option>
                              )
                            })
                          }
                        </Select>
                      </Form.Item>
                      <Tooltip title={t(`dataTarget.promptText`)}>
                        <QuestionCircleOutlined style={{marginTop: 38}}/>
                      </Tooltip>
                    </Col>
                    {
                      this.state.keyVaultValue ?
                        <>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="username" label={t(`dataTarget.username`)}
                                       rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.username`)}`}]}>
                              <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={() => { this.setState({isTested: false}) }}>
                                {
                                  this.state.userList.length > 0 && this.state.userList.map((item) => {
                                    return (
                                      <Select.Option key={item} value={item}>{item}</Select.Option>
                                    )
                                  })
                                }
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="password" label={t(`dataTarget.password`)}
                                       rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.password`)}`}]}>
                              <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={() => { this.setState({isTested: false}) }}>
                                {
                                  this.state.userList.length > 0 && this.state.userList.map((item) => {
                                    return (
                                      <Select.Option key={item} value={item}>{item}</Select.Option>
                                    )
                                  })
                                }
                              </Select>
                            </Form.Item>
                          </Col>
                        </>
                        :
                        <>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="username" label={t(`dataTarget.username`)}
                                       rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.username`)}`}]}>
                              <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} onChange={() => { this.setState({isTested: false}) }}/>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="password" label={t(`dataTarget.password`)}
                                       rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.password`)}`}]}>
                              <Input.Password maxLength={100} placeholder={t(`general.pleaseEnter`)}
                                              onChange={() => { this.setState({isTested: false}) }}/>
                            </Form.Item>
                          </Col>
                        </>
                    }
                  </>
                ) : this.state.dataTypeValue === 'SFTP' ? (
                  <>
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="address" label={t(`dataTarget.address`)}
                                 rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.address`)}`}]}>
                        <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} onChange={() => { this.setState({isTested: false}) }}/>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="port" label={t(`dataTarget.port`)}
                                 rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.port`)}`}]}>
                        <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} onChange={() => { this.setState({isTested: false}) }}/>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item label={t(`dataTarget.keyVault`)} name="keyVault"
                                 style={{display: 'inline-flex', width: 'calc(100% - 30px)', marginRight: '10px'}}>
                        <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeKeyVault} onClear={this.onClearKeyVault}>
                          {
                            this.state.keyVaultList.length > 0 && this.state.keyVaultList.map((item) => {
                              return (
                                <Select.Option key={item.id} value={item.id}>{item.keyVaultName}</Select.Option>
                              )
                            })
                          }
                        </Select>
                      </Form.Item>
                      <Tooltip title={t(`dataTarget.promptText`)}>
                        <QuestionCircleOutlined style={{marginTop: 38}}/>
                      </Tooltip>
                    </Col>
                    {
                      this.state.keyVaultValue ?
                        <>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="username" label={t(`dataTarget.username`)}
                                       rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.username`)}`}]}>
                              <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={() => { this.setState({isTested: false}) }}>
                                {
                                  this.state.userList.length > 0 && this.state.userList.map((item) => {
                                    return (
                                      <Select.Option key={item} value={item}>{item}</Select.Option>
                                    )
                                  })
                                }
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="password" label={t(`dataTarget.password`)}
                                       rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.password`)}`}]}>
                              <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={() => { this.setState({isTested: false}) }}>
                                {
                                  this.state.userList.length > 0 && this.state.userList.map((item) => {
                                    return (
                                      <Select.Option key={item} value={item}>{item}</Select.Option>
                                    )
                                  })
                                }
                              </Select>
                            </Form.Item>
                          </Col>
                        </>
                        :
                        <>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="username" label={t(`dataTarget.username`)}
                                       rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.username`)}`}]}>
                              <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} onChange={() => { this.setState({isTested: false}) }}/>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="password" label={t(`dataTarget.password`)}
                                       rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.password`)}`}]}>
                              <Input.Password maxLength={100} placeholder={t(`general.pleaseEnter`)}
                                              onChange={() => { this.setState({isTested: false}) }}/>
                            </Form.Item>
                          </Col>
                        </>
                    }
                  </>
                ) : this.state.dataTypeValue === 'Blob' ? (
                  <>
                    {/* <Col span={24}>
                      <Form.Item name='address' label="Address" rules={[{ required: true, message: 'Please enter Address' }]}>
                        <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                      </Form.Item>
                    </Col> */}
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item label={t(`dataTarget.keyVault`)} name="keyVault"
                                 style={{display: 'inline-flex', width: 'calc(100% - 30px)', marginRight: '10px'}}>
                        <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeKeyVault} onClear={this.onClearKeyVault}>
                          {
                            this.state.keyVaultList.length > 0 && this.state.keyVaultList.map((item) => {
                              return (
                                <Select.Option key={item.id} value={item.id}>{item.keyVaultName}</Select.Option>
                              )
                            })
                          }
                        </Select>
                      </Form.Item>
                      <Tooltip title={t(`dataTarget.promptText`)}>
                        <QuestionCircleOutlined style={{marginTop: 38}}/>
                      </Tooltip>
                    </Col>
                    {
                      this.state.keyVaultValue ?
                        <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                          <Form.Item name="connectStr" label={t(`dataTarget.connectionString`)}
                                     rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.connectionString`)}`}]}>
                            <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={() => { this.setState({isTested: false}) }}>
                              {
                                this.state.userList.length > 0 && this.state.userList.map((item) => {
                                  return (
                                    <Select.Option key={item} value={item}>{item}</Select.Option>
                                  )
                                })
                              }
                            </Select>
                          </Form.Item>
                        </Col>
                        :
                        <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                          <Form.Item name="connectStr" label={t(`dataTarget.connectionString`)}
                                     rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.connectionString`)}`}]}>
                            <Input maxLength={500} placeholder={t(`general.pleaseEnter`)} onChange={() => { this.setState({isTested: false}) }}/>
                          </Form.Item>
                        </Col>
                    }
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="containerName" label={t(`dataTarget.containerName`)}
                                 rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.containerName`)}`}]}>
                        <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} onChange={() => { this.setState({isTested: false}) }}/>
                      </Form.Item>
                    </Col>
                    {/* <Col span={24}>
                      <Form.Item name='isPublic' label="IsPublic" rules={[{ required: true, message: 'Please choose IsPublic' }]}>
                        <Radio.Group style={{ display: 'flex' }}>
                          <Radio value={'1'}>Y</Radio>
                          <Radio value={'2'}>N</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col> */}
                  </>
                ) : null
              }

              {
                this.state.targetType ? (
                  <>
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="contentType" label={t(`dataTarget.contentType`)}
                                 rules={[{
                                   required: true,
                                   message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.contentType`)}`,
                                   pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                 }]}>
                        <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onChangeContentType} allowClear>
                          <Select.Option key="XML" value="XML">XML</Select.Option>
                          <Select.Option key="JSON" value="JSON">JSON</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="transportProtocol" label={t(`dataTarget.transportProtocol`)}
                                 rules={[{
                                   required: true,
                                   message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.transportProtocol`)}`,
                                   pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                 }]}>
                        <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onChangetransportProtocol} allowClear>
                          <Select.Option key="HTTP" value="HTTP">HTTP</Select.Option>
                          {this.state.xml ? (<Select.Option key="SOAP" value="SOAP">SOAP</Select.Option>) : null}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="apiUrl" label={t(`dataTarget.apiUrl`)}
                                 rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.apiUrl`)}`}]}>
                        <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="charset" label={t(`dataTarget.charset`)}
                                 rules={[{
                                   required: true,
                                   message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.charset`)}`,
                                   pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                 }]}>
                        <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                          <Select.Option key="GBK" value="GBK">GBK</Select.Option>
                          <Select.Option key="UTF-8" value="UTF8">UTF-8</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    {/* {
                      this.state.xml ? (
                        <Col span={24}>
                          <Form.Item name='pre' label="Pre" rules={[{ required: true, message: 'Please enter Pre', pattern: new RegExp(/\S/) }]}>
                            <TextArea rows={4} placeholder={t(`general.pleaseEnter`)} />
                          </Form.Item>
                        </Col>
                      ) : null
                    } */}

                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="certification" label={t(`dataTarget.certification`)}
                                 rules={[{
                                   required: true,
                                   message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.certification`)}`,
                                   pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                 }]}>
                        <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onChangeCertification} allowClear>
                          <Select.Option key="Basic" value="BASIC">Basic</Select.Option>
                          <Select.Option key="Groovy" value="GROOVY">Groovy</Select.Option>
                          {/* <Select.Option key='OAuth2' value='OAUTH2'>OAuth2.0</Select.Option> */}
                          <Select.Option key="None" value="NONE">None</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    {
                      this.state.certification === 'OAUTH2' ? (
                        <>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="authorization" label={t(`dataTarget.authorization`)}
                                       rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.authorization`)}`}]}>
                              <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeauthorization}>
                                <Select.Option key="GRANTTYPEPASSWORD" value="GRANTTYPEPASSWORD">Grant_type Password</Select.Option>
                                <Select.Option key="CLIENTCREDENTIALS" value="CLIENTCREDENTIALS">Client Credentials</Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>

                          {
                            this.state.authorization === 'GRANTTYPEPASSWORD' ? (
                              <>
                                <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                                  <Form.Item name="username" label={t(`dataTarget.username`)} rules={[{
                                    required: true,
                                    message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.username`)}`,
                                    pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                  }]}>
                                    <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                                  </Form.Item>
                                </Col>

                                <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                                  <Form.Item name="password" label={t(`dataTarget.password`)} rules={[{
                                    required: true,
                                    message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.password`)}`,
                                    pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                  }]}>
                                    <Input.Password maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                                  </Form.Item>
                                </Col>
                              </>
                            ) : null
                          }

                          {
                            this.state.authorization === 'CLIENTCREDENTIALS' ? (
                              <>
                                <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                                  <Form.Item name="clientId" label={t(`dataTarget.clientId`)} rules={[{
                                    required: true,
                                    message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.clientId`)}`,
                                    pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                  }]}>
                                    <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                                  </Form.Item>
                                </Col>

                                <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                                  <Form.Item name="clientSecret" label={t(`dataTarget.clientSecret`)} rules={[{
                                    required: true,
                                    message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.clientSecret`)}`,
                                    pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                  }]}>
                                    <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                                  </Form.Item>
                                </Col>
                              </>
                            ) : null
                          }
                        </>
                      ) : null
                    }

                    {
                      this.state.certification === 'BASIC' ? (
                        <>
                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="username" label={t(`dataTarget.username`)}
                                       rules={[{
                                         required: true,
                                         message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.username`)}`,
                                         pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                       }]}>
                              <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                            <Form.Item name="password" label={t(`dataTarget.password`)}
                                       rules={[{
                                         required: true,
                                         message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.password`)}`,
                                         pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                       }]}>
                              <Input.Password maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                            </Form.Item>
                          </Col>
                        </>
                      ) : null
                    }

                    {
                      this.state.certification === 'GROOVY' ? (
                        <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                          <Form.Item label={t(`dataTarget.groovy`)}>
                            <Row gutter={8}>
                              <Col span={20}>
                                <Form.Item name="groovy"
                                           rules={[{
                                             required: true,
                                             message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.groovy`)}`,
                                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                           }]}>
                                  <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangegroovy}>
                                    {
                                      this.state.groovyOption.map((e, i) => {
                                        return (
                                          <Select.Option key={e.id} value={e.id}>{e.name}</Select.Option>
                                        )
                                      })
                                    }
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Button type="link" icon={<EyeOutlined/>} onClick={this.handleVer} title={t(`general.display`)}/>
                              </Col>
                            </Row>
                          </Form.Item>
                        </Col>
                      ) : null
                    }
                    {
                      this.state.targetType ? (
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                          <Row style={{width: '100%', marginBottom: 20}}>
                            <Form.List name="Header" initialValue={[{key: '', value: ''}]}>
                              {(fields, {add, remove}) => (
                                <>
                                  <Col span={24} style={{paddingRight: '16px', fontSize: '16px'}}>Header</Col>
                                  <Col span={24}>
                                    <Table dataSource={fields} pagination={false}>
                                      <Table.Column title={t(`dataTarget.key`)} dataIndex="key" key="key" render={(text, row, index) => {
                                        return (
                                          <Form.Item name={[row.name, 'key']} rules={[{
                                            required: false,
                                            message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.key`)} ${t(`dataTarget.withoutSpecialChats`)}`,
                                            pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                          }]}>
                                            <Input/>
                                          </Form.Item>
                                        )
                                      }}/>
                                      <Table.Column title={t(`dataTarget.value`)} dataIndex="value" key="value" render={(text, row, index) => {
                                        return (
                                          <Form.Item name={[row.name, 'value']} rules={[{
                                            required: false,
                                            message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.value`)} ${t(`dataTarget.withoutSpecialChats`)}`,
                                            pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                          }]}>
                                            <Input/>
                                          </Form.Item>
                                        )
                                      }}/>
                                      <Table.Column align="center" title={t(`general.action`)} key="Action" render={(text, row, index) => {
                                        return (
                                          <>
                                            <Button type="link" onClick={() => add()} icon={<PlusOutlined/>} title={t(`general.add`)}
                                                    style={{marginRight: '10px'}}/>
                                            <Button type="link"
                                                    onClick={() => { if (this.formRef.current.getFieldsValue().Header.length > 1) { remove(index) } }}
                                                    icon={<MinusOutlined/>} title={t(`general.delete`)}/>
                                          </>
                                        )
                                      }}/>
                                    </Table>
                                  </Col>
                                </>
                              )}
                            </Form.List>
                          </Row>

                          {/* <Row style={{ width: '100%' }}>
                            <Form.List name='Body' initialValue={[{ key: '', value: '' }]}>
                              {(fields, { add, remove }) => (
                                <>
                                  <Col span={4} style={{ textAlign: 'right', paddingRight: '16px', fontSize: '16px' }}>Body:</Col>
                                  <Col span={19}>
                                    <Table dataSource={fields} pagination={false}>
                                      <Table.Column title='Key' dataIndex="key" key="key" render={(text, row, index) => {
                                        return (
                                          <Form.Item name={[row.name, 'key']} rules={[{ required: false, message: 'Please enter Key without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                                            <Input />
                                          </Form.Item>
                                        )
                                      }} />
                                      <Table.Column title='Value' dataIndex="value" key="value" render={(text, row, index) => {
                                        return (
                                          <Form.Item name={[row.name, 'value']} rules={[{ required: false, message: 'Please enter value without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                                            <Input />
                                          </Form.Item>
                                        )
                                      }} />
                                      <Table.Column align='center' title="Action" key="Action" render={(text, row, index) => (
                                        <>
                                          <Button type='link' onClick={() => add()} icon={<PlusOutlined />} title='Add' style={{ marginRight: '10px' }} />
                                          <Button type='link' onClick={() => remove(index)} icon={<MinusOutlined />} title='Delete' />
                                        </>
                                      )} />
                                    </Table>
                                  </Col>
                                </>
                              )}
                            </Form.List>
                          </Row> */}
                        </Col>
                      ) : null
                    }
                  </>
                ) : null
              }

              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                <Form.Item name="description" label={t(`dataTarget.description`)}
                           rules={[{
                             message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.description`)} ${t(`dataTarget.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <TextArea rows={4}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Form ref={this.formRefOperation} key="formRefOperation" style={{display: this.state.current !== '1' ? 'none' : ''}}>
            <Row justify="start" gutter={[10, 0]}>
              {
                this.state.transportProtocol === 'HTTP' ? (
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                    <Row>
                      <Form.List name="operationH"
                                 initialValue={[{id: 'HTTP_0', operationName: '', method: 'GET'}, {id: 'HTTP_1', operationName: '', method: 'POST'}]}>
                        {(fields, {add, remove}) => (
                          <>
                            <Col span={24} style={{paddingTop: '5px', paddingRight: '8px', fontSize: '16px'}}>{t(`dataTarget.operation`)}</Col>
                            <Col span={24}>
                              <Table dataSource={fields} pagination={false}>
                                <Table.Column title={t(`dataTarget.operationName`)} dataIndex="operationName" key="operationName"
                                              render={(text, row, index) => {
                                                return (
                                                  <Form.Item name={[row.name, 'operationName']} rules={[{
                                                    required: false,
                                                    message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.operationName`)} ${t(`dataTarget.withoutSpecialChats`)}`,
                                                    pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                                  }]}>
                                                    <Input/>
                                                  </Form.Item>
                                                )
                                              }}/>
                                <Table.Column title={t(`dataTarget.method`)} dataIndex="method" key="method" render={(text, row, index) => {
                                  return (
                                    <Form.Item name={[row.name, 'method']}>
                                      <Input disabled/>
                                    </Form.Item>
                                  )
                                }}/>
                                {/* <Table.Column align='center' title="Action" key="Action" render={(text, row, index) => (
                                            <>
                                              <Button type='link' onClick={() => this.handleEdit(index, 'Add Http Operation')} icon={<EditOutlined />} title='Edit' />
                                            </>
                                          )} /> */}
                              </Table>
                            </Col>
                          </>
                        )}
                      </Form.List>
                    </Row>
                  </Col>
                ) : null
              }
              {
                this.state.transportProtocol === 'SOAP' ? (
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                    <Row>
                      <Form.List name="operationS" initialValue={[{operationName: '', soapAction: '', nameSpace: ''}]}>
                        {(fields, {add, remove}) => (
                          <>
                            <Col span={24} style={{paddingTop: '5px', paddingRight: '8px', fontSize: '16px'}}>{t(`dataTarget.operationName`)}</Col>
                            <Col span={24}>
                              <Table dataSource={fields} pagination={false}>
                                <Table.Column title={t(`dataTarget.operationName`)} dataIndex="operationName" key="operationName"
                                              render={(text, row, index) => {
                                                return (
                                                  <Form.Item name={[row.name, 'operationName']} rules={[{
                                                    required: false,
                                                    message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.operationName`)} ${t(`dataTarget.withoutSpecialChats`)}`,
                                                    pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                                  }]}>
                                                    <Input/>
                                                  </Form.Item>
                                                )
                                              }}/>
                                <Table.Column title={t(`dataTarget.soapAction`)} dataIndex="soapAction" key="soapAction"
                                              render={(text, row, index) => {
                                                return (
                                                  <Form.Item name={[row.name, 'soapAction']} rules={[{
                                                    required: false,
                                                    message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.soapAction`)} ${t(`dataTarget.withoutSpecialChats`)}`,
                                                    pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                                  }]}>
                                                    <Input/>
                                                  </Form.Item>
                                                )
                                              }}/>
                                <Table.Column title={t(`dataTarget.namesPace`)} dataIndex="nameSpace" key="nameSpace" render={(text, row, index) => {
                                  return (
                                    <Form.Item name={[row.name, 'nameSpace']} rules={[{
                                      required: false,
                                      message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.namesPace`)} ${t(`dataTarget.withoutSpecialChats`)}`,
                                      pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                    }]}>
                                      <Input/>
                                    </Form.Item>
                                  )
                                }}/>
                                <Table.Column align="center" title={t(`general.action`)} key="Action" render={(text, row, index) => (
                                  <>
                                    <Button type="link" onClick={() => add()} icon={<PlusOutlined/>} title={t(`general.add`)}
                                            style={{marginRight: '5px'}}/>
                                    <Button type="link"
                                            onClick={() => { if (this.formRefOperation.current.getFieldsValue().operationS.length > 1) { remove(index) } }}
                                            icon={<MinusOutlined/>} title={t(`general.delete`)}/>
                                  </>
                                )}/>
                              </Table>
                            </Col>
                          </>
                        )}
                      </Form.List>
                    </Row>
                  </Col>
                ) : null
              }
            </Row>
          </Form>
          <Form ref={this.formRefAdition} key="formRefAdition" style={{display: this.state.current !== '2' ? 'none' : ''}}>
            <Row justify="start" gutter={[10, 0]}>
              {
                this.state.transportProtocol === 'SOAP' ? (
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                    <Row style={{width: '100%'}}>
                      <Form.List name="soapHeader" initialValue={[{key: '', value: ''}]}>
                        {(fields, {add, remove}) => (
                          <>
                            <Col span={24} style={{paddingRight: '8px', fontSize: '16px'}}>{t(`dataTarget.soapHeader`)}</Col>
                            <Col span={24}>
                              <Table dataSource={fields} pagination={false}>
                                <Table.Column title={t(`dataTarget.key`)} dataIndex="key" key="key" render={(text, row, index) => {
                                  return (
                                    <Form.Item name={[row.name, 'key']} rules={[{
                                      required: false,
                                      message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.key`)} ${t(`dataTarget.withoutSpecialChats`)}`,
                                      pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                    }]}>
                                      <Input/>
                                    </Form.Item>
                                  )
                                }}/>
                                <Table.Column title={t(`dataTarget.value`)} dataIndex="value" key="value"
                                              render={(text, row, index) => {
                                                return (
                                                  <Form.Item name={[row.name, 'value']} rules={[{
                                                    required: false,
                                                    message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.value`)} ${t(`dataTarget.withoutSpecialChats`)}`,
                                                    pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                                                  }]}>
                                                    <Input/>
                                                  </Form.Item>
                                                )
                                              }}/>
                                <Table.Column align="center" title={t(`general.action`)} key="Action"
                                              render={(text, row, index) => (
                                                <>
                                                  <Button type="link" onClick={() => add()} icon={<PlusOutlined/>}
                                                          title={t(`general.add`)} style={{marginRight: '10px'}}/>
                                                  <Button type="link" onClick={() => {
                                                    if (this.formRefAdition.current.getFieldsValue().soapHeader.length > 1) {
                                                      remove(index)
                                                    }
                                                  }} icon={<MinusOutlined/>} title={t(`general.delete`)}/>
                                                </>
                                              )}/>
                              </Table>
                            </Col>
                          </>
                        )}
                      </Form.List>
                    </Row>
                  </Col>
                ) : null
              }
            </Row>
          </Form>
        </Modal>
        {this.state.verModalVisible ?
          <VerModal handlePopupCancel={this.handlePopupCancel} id={this.state.groovyPopup} verModalVisible={this.state.verModalVisible}/> : null}
      </>
    )
  }
}

export default withTranslation()(EditModal)
